import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLinkR } from './SidebarElements'

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
          <CloseIcon />
        </Icon>
        <SidebarWrapper>
          <SidebarMenu>
            <SidebarLinkR to="/" smooth={true} onClick={toggle}>
              Produkter
            </SidebarLinkR>
            <SidebarLinkR to="/about" smooth={true} onClick={toggle}>
              Om Oss
            </SidebarLinkR>
            <SidebarLinkR to="/login" smooth={true} duration={2500} offset={-20} onClick={toggle} className='sidebarLink'>
              Logga In
            </SidebarLinkR>
          </SidebarMenu>
        </SidebarWrapper>
    </SidebarContainer>
  )
}

export default Sidebar